import React from 'react';
import {useParams} from "react-router-dom"
import CarouselForm from './CarouselForm';

export default function EditCarousel() {
  const { id } = useParams();
  return <CarouselForm id={id} />;
}
